import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "InvoicesModule"
const debug = false

export class InvoicesModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.INVOICES, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                      = "Invoices"
        this.description               = "With the Invoices module, you can easily create and manage invoices within your workspace. This feature allows for the generation of professional invoices, tracking of payments, and efficient management of billing details. Invoices module is currently in closed beta testing and will be released publicly soon. "
        this.svgIcon                   = "isvg-invoices"
        this.settingsMenuTopCategory   = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                 = "Finance"
        this.settingsUrl               = "settings/invoices"
        this.parentSection          = SettingsParentSection.FINANCE

        this._isEnabled                 = false
        this.canDisable                 = false

        this.hasStatus                  = false
        this.isComingSoon               = true

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}